/**
 * XML parsing options
 *
 * @group XML
 *
 * @beta
 */
export type XmlParseOptions = {
	pos?: number;
	keepWhitespace?: boolean;
	keepComments?: boolean;
};
